module.exports = __webpack_public_path__ + "img/img-9.036bd540.png";